<template>
  <a-card>
    <a-tabs default-active-key="1" @change="getTableData">
      <a-tab-pane v-for="item in tabsList" :key="item.id" :tab="item.name"/>
      <a-button slot="tabBarExtraContent" v-permission="`Auth.Deploy.Save`" icon="save" :loading="saveLoading"
                type="primary" @click="submitRole"> 保存
      </a-button>
    </a-tabs>
    <a-card style="margin-top: 20px" class="table">
      <a-table :loading="pageLoading" :columns="columns" rowKey="id" :pagination="false" :data-source="authorizeList">
        <template slot="name" slot-scope="text, record">
          <a-checkbox :class="isHalf(record) ? 'check-half' : ''" :checked="isChecked(record)" v-if="isChildren(record)"
                      @change="onCheckChange($event, record)">
            <span :title="text">{{ text }}</span>
          </a-checkbox>
          <span v-else :title="text">{{ text }}</span>
        </template>
        <template slot="action" slot-scope="text">
          <span v-for="(item, index) in text.authority" :key="item.name + item.id + index"
                style="margin-right: 15px; display: inline-block">
            <a-checkbox v-model="item.flag" @change="changeItem($event, index, text.authority)"> {{
                item.name
              }}
            </a-checkbox>
          </span>
        </template>
      </a-table>
    </a-card>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import {mapState} from 'vuex'

const columns = [
  {
    title: '模块',
    dataIndex: 'name',
    width: '250px',
    key: 'name',
    ellipsis: true,
    scopedSlots: {customRender: 'name'},
  },
  {
    title: '权限',
    scopedSlots: {customRender: 'action'},
  },
]

export default {
  name: 'Deploy',
  computed: {
    ...mapState('setting', ['theme']),
    isChildren() {
      return function (record) {
        const flag1 = record.children && record.children.length
        const flag2 = record.authority && record.authority.length
        return flag1 || flag2
      }
    },
    isChecked() {
      return function (record) {
        const flag1 = record?.authority?.some((v) => v.flag === false)
        let flag2 = false
        const children = record.children || []
        const stack = [...children]
        while (stack.length) {
          const item = stack.pop()
          flag2 = item?.authority?.some((v) => v.flag === false)
          if (flag2) return false
          const itemChildren = item.children
          if (itemChildren && itemChildren.length) {
            itemChildren.forEach((v) => stack.push(v))
          }
        }
        return !flag1 && !flag2
      }
    },
    /** 判断半选 */
    isHalf() {
      return function (record) {
        const children = [...(record.children || []), ...(record.authority || [])].flat(10)
        const stack = [...children]
        const tf = {
          t: 0,
          f: 0,
        }

        while (stack.length) {
          const item = stack.pop()
          item.flag === true && tf.t++
          item.flag === false && tf.f++
          if (tf.t && tf.f) {
            return true
          }
          const itemChildren = [...(item.children || []), ...(item.authority || [])].flat(10)
          if (itemChildren && itemChildren.length) {
            itemChildren.forEach((v) => stack.push(v))
          }
        }
        return tf.t && tf.f ? true : false
      }
    },
  },
  data() {
    return {
      tabsList: [],
      columns,
      authorizeList: [],
      pageLoading: false,
      saveLoading: false,
      appid: undefined,
    }
  },
  created() {
    $Bus.$emit('pageHeaderTitle', this.$route.query.name + '权限配置')
    this.setTitle()
    this.getApplyList()
  },
  methods: {
    /** 判断是否全选 */
    isCheckedAll() {
      const data = this.authorizeList.map((v) => v.children).flat(10)
      let ind = data.length - 1
      while (ind >= 0) {
        const item = data[ind]
        const flag1 = item.authority?.some((v) => v.flag === false)
        const flag2 = item.children?.some((v) => v.authority?.some((c) => c.flag === false))
        ind--
        if (flag1 || flag2) return false
      }
      return true
    },
    changeItem(e, index, item) {
      this.$set(item[index], 'flag', e.target.checked)
    },
    /** 勾选某一模块 */
    onCheckChange(e, record) {
      this.resverAuthority([record], e.target.checked)
    },
    /** 改变勾选状态 */
    resverAuthority(data, flag) {
      data.forEach((v) => {
        if (v.hasOwnProperty('flag')) {
          v.flag = flag
        }
        if (v.authority && v.authority.length) {
          v.authority?.forEach((v) => (v.flag = flag))
        }
        if (v.children && v.children.length) {
          this.resverAuthority(v.children, flag)
        }
      })
    },
    setTitle() {
      const arr = ['首页', '权限系统', {name: '系统角色', path: '/settings/Roles'}, this.$route.query.name + '权限配置']
      $Bus.$emit('pageHeaderBreadcrumb', arr)
    },
    getApplyList() {
      this.$http.applicationList({roleType: this.$route.query.roleType}).then((res) => {
          this.tabsList = res.data.data
          this.appid = res.data.data[0].id
          this.getTableData(this.appid)
       
      })
    },

    getTableData(appid) {
      this.appid = appid
      let params = {
        roleid: this.$route.query.id,
        appid: appid,
      }
      this.pageLoading = true
      this.$http.getauthorize(params).then((res) => {
        this.pageLoading = false
        const data = res.data
          this.authorizeList = data.map((m) => ({
            ...m,
            name: m.authorityTypeName,
            id: +new Date(),
            children: editTree(m.roleModuleAuthorizeConfigs),
          }))

      })

      function editTree(tree, id = 0) {
        return tree
          .filter((f) => f.parentId === id)
          .map((m) => {
            const children = editTree(tree, m.id)
            return {
              ...m,
              children: children.length ? children : undefined,
            }
          })
      }
    },

    submitRole() {
      const Params = {
        roleAuthorityItems: this.authorizeList.map((m) => {
          const authIds = []
          getFlag(m.children, authIds)
          return {
            appid: this.appid,
            authIds,
            authorityType: m.authorityType,
            roleId: this.$route.query.id,
          }
        }),
      }
      this.saveLoading = true
      this.$http.editauthorize(Params).then((res) => {
        this.saveLoading = false
          this.$message.success('配置成功')
        
      })

      function getFlag(tree, arr = []) {
        for (let i = 0; i < tree.length; i++) {
          for (let j = 0; j < tree[i].authority.length; j++) {
            const item = tree[i].authority[j]
            if (item.flag) {
              arr.push(item.id)
            }
          }
          if (tree[i].children && tree[i].children.length) {
            getFlag(tree[i].children, arr)
          }
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.table {
  /deep/ .ant-checkbox-wrapper {
    display: inline;
  }

  .check-half {
    ::v-deep .ant-checkbox-inner {
      background: #fff;
      position: relative;
    }

    ::v-deep .ant-checkbox-inner::after {
      content: '';
      width: 8px;
      height: 8px;
      display: inline-block;
      background: var(--color);
      top: 50%;
      left: 50%;
      border: 0;
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }
}
</style>
